export default __webpack_public_path__ + "static/media/user.10c4e520.webp";